/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Invalid_Next_TaskInputs */

const en_api_error_task_invalid_next_task = /** @type {(inputs: Api_Error_Task_Invalid_Next_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose one of the next activities allowed for this resolution.`)
};

const pt_br2_api_error_task_invalid_next_task = /** @type {(inputs: Api_Error_Task_Invalid_Next_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha uma das próximas atividades permitidas para esta resolução.`)
};

/**
* | output |
* | --- |
* | "Choose one of the next activities allowed for this resolution." |
*
* @param {Api_Error_Task_Invalid_Next_TaskInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_invalid_next_task = /** @type {((inputs?: Api_Error_Task_Invalid_Next_TaskInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Invalid_Next_TaskInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_invalid_next_task(inputs)
	return pt_br2_api_error_task_invalid_next_task(inputs)
});